var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',[_vm._v("欢迎使用最强牛人后台管理系统")])
}
var staticRenderFns = []

export { render, staticRenderFns }